import LogoutIcon from "@mui/icons-material/Logout";
import { Button, Stack } from "@mui/material";
import React from "react";

interface PengaturanAccountActionsProps {
    showJuraganButton: boolean;
    onLogout: () => void;
}

const juraganUrl =
    process.env.NODE_ENV === "production"
        ? "https://juragan.ukmlokal.com"
        : "http://localhost:3000";

const PengaturanAccountActions = ({
    showJuraganButton,
    onLogout,
}: PengaturanAccountActionsProps) => {
    return (
        <Stack direction="row" mt={3} ml={3} spacing={2}>
            {showJuraganButton && (
                <Button variant="outlined" href={juraganUrl} rel="noreferrer">
                    Ke Juragan
                </Button>
            )}
            <Button
                variant="contained"
                color="error"
                onClick={onLogout}
                startIcon={<LogoutIcon />}
            >
                Keluar
            </Button>
        </Stack>
    );
};

export default PengaturanAccountActions;
